// Copyright (c) 2023 WiseTime. All rights reserved.

import { concat, forkJoin, Observable, of } from "rxjs"
import { catchError, filter, mergeMap, withLatestFrom } from "rxjs/operators"
import { Action } from "redux"
import { RootState } from "../../../app/store"
import { t } from "@lingui/macro"
import * as Actions from "../actions"
import { showSnackBar } from "../../snackbar/actions"
import { detachTagFulfilled, detachTagRpc, DetachTagRpc } from "./detachTag"
import { attachTagFulfilled, attachTagRpc, AttachTagRpc } from "./attachTag"

export const replaceTag = (attachTagRpc: AttachTagRpc, detachTagRpc: DetachTagRpc) =>
  (action$: Observable<Action>, state$: Observable<RootState>): Observable<Action> =>
    action$.pipe(
      filter(Actions.replaceTag.match),
      withLatestFrom(state$),
      mergeMap(([{
        payload: {
          attachTagRequest,
          detachTagRequest,
          tag,
          onError,
        }}, state]) =>
        forkJoin([attachTagRpc(attachTagRequest), detachTagRpc(detachTagRequest)])
          .pipe(
            mergeMap(_ => concat(
              attachTagFulfilled(attachTagRequest, tag, state),
              detachTagFulfilled(detachTagRequest, state),
            )),
            catchError(_ => {
              onError()
              return concat(
                of(showSnackBar({
                  message: t({ id: "msg_replace_tag_failed", message: "Failed to replace tag. Please try again in a couple of minutes. If the error persists, please contact support@wisetime.com." }),
                  messageType: "ERROR",
                })),
                of(Actions.onTimelineOutOfSync()),
              )
            }),
          )
      ),
    )

export default replaceTag(attachTagRpc, detachTagRpc)
